export default __webpack_public_path__ + "static/media/grayVector.db5139a8.svg";